import React from "react";
import Hero from "../Hero";
import Spacing from "../Spacing";
import About from "../About";
import WhyChose from "../WhyChose";
import Service from "../Service";
import Portfolio from "../Portfolio";
import Button from "../Button";
import SectionHeading from "../SectionHeading";
import Accordion from "../Accordion";
import { pageTitle } from "../../helpers/PageTitle";
import { ImageConstants } from "../../assets/ImageConstants";
// import WhatsappButton from "./WhatsappButton";

const funfactData = [
  { title: "Premium Sports Courts", number: "7" },
  { title: "Successful Matches Played", number: "2k" },
  { title: "Active Players & Members", number: "1k" },
  { title: "Tournaments & Events Hosted", number: "121" },
];
const whyChoseFeatureData = [
  {
    title: "Premium Multi-Sport Facilities ",
    content:
      "Enjoy access to top-tier courts and equipment designed for athletes and enthusiasts alike.",
  },
  {
    title: "Expert Coaching & Programs ",
    content:
      "Train with certified professionals across Padel & Futsal, tailored to all skill levels.",
  },
  {
    title: "Engaging Community & Events ",
    content:
      "From private events to corporate away days, experience a dynamic environment built for sport, connection, and fun.",
  },
];
const serviceListData = [
  {
    title: "Sports Training",
    subtitle: "Expert coaching in Padel & Futsal  for all skill levels.",
    imgUrl: "/images/creative-agency/service_6.jpg",
    href: "/shop/booking",
    imgStyle: {},
  },
  {
    title: "Premium Facilities",
    subtitle:
      "Access to 6 Padel courts, 2 Futsal courts, and a multi-purpose court.",
    imgUrl: "/images/creative-agency/service_7.jpeg",
    href: "/shop/booking",
    imgStyle: {},
  },
  {
    title: "Events & Team Building",
    subtitle:
      "Custom experiences for corporate away days, private events, and group activities.",
    imgUrl: "/images/creative-agency/service_8.jpeg",
    href: "/shop/booking",
    imgStyle: {},
  },
  {
    title: "Leisure Area",
    subtitle:
      "A vibrant eating space to relax, refuel, and socialize post-game.",
    imgUrl: "/images/creative-agency/service_10.jpeg",
    href: "/shop/booking",
    imgStyle: {},
  },
];
const portfolioData = [
  {
    href: "/court/court-detail?type=padel&court=1",
    imgUrl: "/images/creative-agency/padelcourt1.jpeg",
    title: " Padel Court 01",
    btnText: "",
    imgStyle: {},
  },
  {
    href: "/court/court-detail?type=padel&court=2",
    imgUrl: "/images/creative-agency/padelcourt2.jpeg",
    title: " Padel Court 02",
    btnText: "",
    imgStyle: {},
  },
  {
    href: "/court/court-detail?type=padel&court=3",
    imgUrl: "/images/creative-agency/padelcourt3.jpeg",
    title: " Padel Court 03",
    // btnText: "",
    imgStyle: {},
  },
  {
    href: "/court/court-detail?type=padel&court=4",
    imgUrl: "/images/creative-agency/padel4.jpeg",
    title: " Padel Court 04",
    // btnText: "",
    imgStyle: {},
  },
];
const awardData = [
  {
    brand: "Behance",
    title: "UI/UX design of the month",
    subTitle:
      "Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores",
    date: "December 12, 2023",
    awardImgUrl: "/images/creative-agency/award_img_1.svg",
  },
  {
    brand: "Awwwards",
    title: "CSS awards design",
    subTitle:
      "Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores",
    date: "January 05, 2022",
    awardImgUrl: "/images/creative-agency/award_img_2.svg",
  },
  {
    brand: "Google",
    title: "Website of the day",
    subTitle:
      "Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores",
    date: "March 20, 2021",
    awardImgUrl: "/images/creative-agency/award_img_3.svg",
  },
];
const testimonialData = [
  {
    text: "Ignite Sports Pavilion is the best place to train and play. The padel courts are top-notch, and the coaching staff is incredibly professional. I've seen a huge improvement in my game!",
    avatarName: "Muhammad Ahmed ",
    // avatarDesignation: "CEO at Delta",
  },
  {
    text: "Playing at Ignite Sports Pavilion has been an amazing experience. The Futsal fields are well-maintained, and the community here is fantastic. Whether it's casual games or competitive leagues, this place has it all!",
    avatarName: "Haris Irfan",
    // avatarDesignation: " ",
  },
  {
    text: "Ignite Sports Pavilion offers one of the best Multi Purpose setups in the city. The pitches are excellent, and the tournaments are well-organized. It's my go-to place for weekend matches.",
    avatarName: "Muhammad Azam",
    // avatarDesignation: "",
  },
];
const faqData = [
  {
    title: "01. How can I book a court or training session?",
    content:
      "You can book directly through our website or by calling us at +92 319 3446483. Our team will be happy to assist you with availability and any special requests.",
  },
  {
    title: "02. What are your operating hours?",
    content:
      "We're open late to suit your schedule:\n• Monday to Wednesday: 7:00 AM – 3:00 AM\n• Thursday to Sunday: 7:00 AM – 4:00 AM",
  },
  {
    title: "03. When are your peak hours?",
    content:
      "Our peak hours typically see higher demand:\n• •	Monday to Wednesday: 5:00 PM – 3:00 AM\n• •	Thursday to Sunday: 5:00 PM – 4:00 AM",
  },
  {
    title: "04. What sports facilities do you offer?",
    content:
      "We offer 6 Padel courts, 2 Futsal courts, and a multi-purpose court suitable for volley ball, Throw ball & Multi Purpose ",
  },
  {
    title: "05. Do you offer coaching or training programs?",
    content:
      "Yes! We provide professional coaching in Padel & Futsal for all age groups and skill levels.",
  },
  {
    title:
      "06. Can I host private or corporate events at Ignite Sports Pavilion?",
    content:
      "Absolutely. We host corporate away days, team-building events, and private sports gatherings tailored to your needs.",
  },
  {
    title: "07. Is there a space to relax or dine?",
    content:
      "Yes, we have a vibrant eating area where players and guests can relax, refuel, and socialize.",
  },
  {
    title: "08. Do I need to bring my own equipment?",
    content:
      "You're welcome to bring your own gear, but we also have equipment available on-site. Please contact us in advance for availability.",
  },
  {
    title: "09. Is parking available?",
    content: "Yes, we offer convenient on-site parking for players and guests.",
  },
  {
    title: "10. How can I stay updated on events and promotions?",
    content:
      "Follow us on social media and subscribe to our newsletter through the website for the latest updates, offers, and upcoming events.",
  },
];

const postData = [
  {
    thumbnailSrc: "/images/creative-agency/service_10.jpeg",
    title: "Top Benefits of Playing Padel: Why It's the Fastest-Growing Sport",
    date: "07 Mar 2023",
    url: "#",
  },
  {
    thumbnailSrc: "/images/creative-agency/service_7.jpeg",
    title: "How to Choose the Perfect Padel Court for Your Game",
    date: "22 Jan 2025",
    url: "#",
  },
  {
    thumbnailSrc: "/images/creative-agency/service_8.jpeg",
    title: "Essential Padel Tips for Beginners to Improve Fast",
    date: "13 May 2024",
    url: "#",
  },
  {
    thumbnailSrc: "/images/creative-agency/service_10.jpeg",
    title: "Your agency need to replace some artistic mind people",
    date: "15 Mar 2024",
    url: "#",
  },
];

export default function Home() {
  pageTitle("Ignite");
  return (
    <>
      <style>
        {`
          .cs_section_heading.cs_style_1 p.m-0:last-of-type {
            text-align: justify !important;
          }
          
          /* Coaching Section Styles */
          .cs_coaching_card {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 20px;
            padding: 40px 30px;
            height: 100%;
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }
          
          .cs_coaching_card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
            z-index: 1;
          }
          
          .cs_coaching_card_inner {
            position: relative;
            z-index: 2;
            text-align: center;
            height: 100%;
            display: flex;
            flex-direction: column;
          }
          
          .cs_coaching_card:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
            border-color: rgba(255, 255, 255, 0.3);
          }
          
          .cs_coaching_icon {
            width: 80px;
            height: 80px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 25px;
            color: white;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
          }
          
          .cs_coaching_title {
            font-size: 28px;
            font-weight: 700;
            color: white;
            margin-bottom: 20px;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          
          .cs_coaching_desc {
            font-size: 16px;
            color: rgba(255, 255, 255, 0.9);
            line-height: 1.6;
            margin-bottom: 25px;
            flex-grow: 1;
          }
          
          .cs_coaching_features {
            list-style: none;
            padding: 0;
            margin: 0 0 30px 0;
            text-align: left;
          }
          
          .cs_coaching_features li {
            color: rgba(255, 255, 255, 0.9);
            font-size: 15px;
            margin-bottom: 12px;
            position: relative;
            padding-left: 25px;
          }
          
          .cs_coaching_features li::before {
            content: '✓';
            position: absolute;
            left: 0;
            color: #00f3ff;
            font-weight: bold;
            font-size: 16px;
          }
          
          .cs_coaching_card .cs_btn {
            margin-top: auto;
            padding: 15px 30px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
            border-radius: 50px;
            transition: all 0.3s ease;
            background: transparent;
            border: 2px solid #00f3ff;
            color: #00f3ff;
            text-decoration: none;
            display: inline-block;
            position: relative;
            overflow: hidden;
          }
          
          // .cs_coaching_card .cs_btn::after {
          //   content: '→';
          //   margin-left: 8px;
          //   transition: all 0.3s ease;
          // }
          
          .cs_coaching_card .cs_btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 25px rgba(0, 243, 255, 0.3);
            background: rgba(0, 243, 255, 0.1);
            border-color: #00f3ff;
            color: #00f3ff;
          }
          
          .cs_coaching_card .cs_btn:hover::after {
            transform: translateX(3px);
          }
          
          @media (max-width: 768px) {
            .cs_coaching_card {
              padding: 30px 20px;
              margin-bottom: 30px;
            }
            
            .cs_coaching_title {
              font-size: 24px;
            }
            
            .cs_coaching_icon {
              width: 70px;
              height: 70px;
            }
          }
        `}
      </style>
      <Hero
        title={[""]}
        subtitle=" "
        bgUrl={ImageConstants.videoBanner}
        imgStyle={{}}
      />
      <div className="container">
        <div
          className="row"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            margin: "40px 0",
          }}
        >
          {[
            {
              src: "/images/creative-agency/6%20padel%20court.png",
              alt: "6 Padel Courts",
              style: { height: "127px" },
            },
            { src: "/images/creative-agency/2.svg", alt: "2 Futsal Courts" },
            { src: "/images/creative-agency/1.svg", alt: "1 Multi Purpose Court" },
            { src: "/images/creative-agency/3.svg", alt: "1K+ Active Community" },
          ].map((item, index) => (
            <div
              key={index}
              className="col-12 col-md-3"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "24px",
              }}
            >
              <img
                src={item.src}
                alt={item.alt}
                style={{
                  width: "300px",
                  objectFit: "contain",
                  maxWidth: "100%",
                  ...(item.style || {}),
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <About
        thumbnail="/images/creative-agency/about.png"
        imgStyle={{}}
        uperTitle="Who are we? "
        title="Welcome to Ignite Sports Pavilion"
        subTitle="Ignite Sports Pavilion is a premier multi-sport facility designed for athletes, enthusiasts, and active communities. We offer world-class amenities including 6 Padel courts, 2 Futsal courts, and a versatile multi-purpose court for volley ball, throw ball & Multi Purpose "
        para="Whether you're training to compete, staying active, or just playing for fun, Ignite Sports Pavilion provides the perfect space to train, play, and connect. Our expert coaches deliver top-tier programs in Padel & Futsal for all skill levels.We also host corporate away days, private events, and team-building sessions, making Ignite Sports Pavilion the go-to destination for both sport and social engagement."
        featureList={[
          "Professional-Grade Padel Courts",
          "Spacious Futsal Courts",
          "Versatile Multi-Purpose Court",
          "Vibrant Atmosphere & Eating Area",
        ]}
        btnText="Learn More"
        btnUrl="/about"
      />
      <Spacing lg="185" md="75" />
      <WhyChose
        sectionTitle="Your Premier Sports Destination"
        sectionSubTitle="Why Choose Us"
        whyChoseFeatureData={whyChoseFeatureData}
        thumbnailSrc="/images/creative-agency/why.png"
        imgStyle={{}}
      />
      <Spacing lg="150" md="80" />
      <section className="cs_primary_bg">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading
            title="Our core services"
            subTitle="Services"
            variantColor="cs_white_color"
          />
          <Spacing lg="45" md="30" />
        </div>
        <div className="container">
          <Service
            sectionTitle="Our core services"
            sectionSubTitle="Services"
            data={serviceListData}
          />
          <Spacing lg="135" md="65" />
        </div>
      </section>
      
      {/* Coaching Section */}
      {/* <section className="cs_primary_bg">
        <div className="container">
          <SectionHeading
            title="Want to Take Coaching?"
            subTitle="Professional Training"
            variantColor="cs_white_color"
          />
          <Spacing lg="60" md="40" />
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="text-center mb-5">
                <p className="cs_fs_21 cs_white_color mb-0" style={{ opacity: 0.9 }}>
                  Elevate your game with our professional coaching programs. Whether you're a beginner or looking to refine your skills, our certified coaches are here to help you reach your potential.
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center cs_gap_y_30">
            <div className="col-lg-5 col-md-6">
              <div className="cs_coaching_card">
                <div className="cs_coaching_card_inner">
                  <div className="cs_coaching_icon">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H19C20.11 23 21 22.11 21 21V9M19 9H14V4H5V21H19V9Z" fill="currentColor"/>
                    </svg>
                  </div>
                  <h3 className="cs_coaching_title">Group Coaching</h3>
                  <p className="cs_coaching_desc">
                    Join our group sessions and learn alongside other players. Perfect for building skills while enjoying the social aspect of the game.
                  </p>
                  <ul className="cs_coaching_features">
                    <li>10 sessions per month</li>
                    <li>Monday, Wednesday & Thursday</li>
                    <li>PKR 20,000 monthly</li>
                    <li>All skill levels welcome</li>
                  </ul>
                
                    <a 
                    href="/group-padel-coaching-form"
                  className="cs_btn cs_style_1"
                  >
                    Register Now
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-6">
              <div className="cs_coaching_card">
                <div className="cs_coaching_card_inner">
                  <div className="cs_coaching_icon">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H19C20.11 23 21 22.11 21 21V9M19 9H14V4H5V21H19V9Z" fill="currentColor"/>
                    </svg>
                  </div>
                  <h3 className="cs_coaching_title">Private Coaching</h3>
                  <p className="cs_coaching_desc">
                    Get personalized one-on-one training tailored to your specific needs and goals. Accelerate your progress with focused attention.
                  </p>
                  <ul className="cs_coaching_features">
                    <li>Personalized training</li>
                    <li>Flexible scheduling</li>
                    <li>PKR 11,500 per hour</li>
                    <li>Court fee included</li>
                  </ul>
                  <a 
                    href="/private-coaching-form"
                  className="cs_btn cs_style_1"
                  >
                    Register Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Spacing lg="143" md="75" />
      </section>
       */}
      <section>
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading
            title="Our Courts"
            subTitle="Discover our top-quality Padel, Futsal, and Multi Purpose courts."
          />
          <Spacing lg="85" md="45" />
          <Portfolio data={portfolioData} />
          <Spacing lg="26" md="30" />
          <div className="text-center">
            <Button btnText="Explore Courts" btnUrl="/courts" />
          </div>
        </div>
        {/* <Spacing lg="150" md="80" /> */}
      </section>

      <section>
        {/* <Spacing lg="143" md="75" /> */}
        <div className="container" style={{ marginTop: "40px" }}>
          <SectionHeading title="Frequently asked question" subTitle="FAQs" />
          <Spacing lg="55" md="30" />
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <Accordion variant="cs_type_1" data={faqData} />
            </div>
          </div>
        </div>
        <Spacing lg="120" md="50" />
      </section>
      {/* <WhatsappButton /> */}
    </>
  );
}
